var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 20,
    height: 20,
    transform: "translate(12 10)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-12 -10)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M31.6,20.227a11.489,11.489,0,0,0-.182-2.045H22V22.05h5.382a4.6,4.6,0,0,1-2,3.018v2.509h3.232A9.753,9.753,0,0,0,31.6,20.227Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M22,30a9.547,9.547,0,0,0,6.618-2.423l-3.232-2.509A6.033,6.033,0,0,1,16.4,21.9H13.064v2.591A10,10,0,0,0,22,30Z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M16.4,21.9a5.913,5.913,0,0,1,0-3.8V15.509H13.064a10.013,10.013,0,0,0,0,8.982Z",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22,13.977a5.4,5.4,0,0,1,3.823,1.5L28.691,12.6A9.611,9.611,0,0,0,22,10a10,10,0,0,0-8.936,5.509L16.4,18.1A5.96,5.96,0,0,1,22,13.977Z",
    fill: "#e94235"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google_logo.0c9328bb2c42643e61b812db11c61a0e.svg";